import {
    GETOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION,
    CREATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION,
    UPDATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION,
    DELETEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION,
    GETALLOPTICOPDPURCHASEITEMQTY,
    GETOPTICSHOPOPDPURCHASEITEM,
    GETALLOPTICOPDITEMQTY,
    CREATEOPTICSHOPOPDPURCHASEITEM,
    UPDATEOPTICSHOPOPDPURCHASEITEM,
    DELETEOPTICSHOPOPDPURCHASEITEM,
    GETOPTICSHOPOPDGENERATEBILL,
    CREATEOPTICSHOPOPDGENERATEBILL,
    UPDATEOPTICSHOPOPDGENERATEBILL,
    DELETEOPTICSHOPOPDGENERATEBILL,
    GETOPTICSHOPOPDBILLITEM,
    CREATEOPTICSHOPOPDBILLITEM,
    UPDATEOPTICSHOPOPDBILLITEM,
    DELETEOPTICSHOPOPDBILLITEM,
    GETOPTICSHOPOPDBILLTRANSACTION,
    CREATEOPTICSHOPOPDBILLTRANSACTION,
    UPDATEOPTICSHOPOPDBILLTRANSACTION,
    DELETEOPTICSHOPOPDBILLTRANSACTION,
    GETOPTICSHOPOPDPURCHASEITEMBILL,
    CREATEOPTICSHOPOPDPURCHASEITEMBILL,
    UPDATEOPTICSHOPOPDPURCHASEITEMBILL,
    DELETEOPTICSHOPOPDPURCHASEITEMBILL,
    GETOPTICSHOPOPDPURCHASEITEMSHOW,
    CREATEOPTICSHOPOPDPURCHASEITEMSHOW,
    UPDATEOPTICSHOPOPDPURCHASEITEMSHOW,
    DELETEOPTICSHOPOPDPURCHASEITEMSHOW,
    GETOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION,
    CREATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION,
    UPDATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION,
    DELETEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION,
    GETOPTICSHOPOPDBADSTOCK,
    CREATEOPTICSHOPOPDBADSTOCK,
    UPDATEOPTICSHOPOPDBADSTOCK,
    DELETEOPTICSHOPOPDBADSTOCK,

    GETOPTICOPDVISIONCHART,
    CREATEOPTICOPDVISIONCHART,
    UPDATEOPTICOPDVISIONCHART,
    DELETEOPTICOPDVISIONCHART,
} from "../actions/types"

const initialState = {
    OpticShopPurchaseItemUpdateStatus: []
}
export default function (state = initialState, action) {
    switch (action.type) {
        case GETOPTICSHOPOPDBADSTOCK:
            return {
                ...state,
                OpticShopOpdBadStockList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDBADSTOCK:
            return {
                ...state,
                OpticShopOpdBadStockSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDBADSTOCK:
            return {
                ...state,
                OpticShopOpdBadStockUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDBADSTOCK:
            return {
                ...state,
                OpticShopOpdBadStockDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDPURCHASEITEM:
            return {
                ...state,
                OpticShopPurchaseItemList: action.payload.data,
            };
        case GETALLOPTICOPDPURCHASEITEMQTY:
            return {
                ...state,
                OpticShopOpddPurchaseItemList: action.payload.data,
            };
        case GETALLOPTICOPDITEMQTY:
            return {
                ...state,
                OpticShopQtyItemList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDPURCHASEITEM:
            return {
                ...state,
                OpticShopPurchaseItemSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDPURCHASEITEM:
            return {
                ...state,
                OpticShopPurchaseItemUpdateStatus: action.payload.success,
            };

        case DELETEOPTICSHOPOPDPURCHASEITEM:
            return {
                ...state,
                OpticShopPurchaseItemDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDGENERATEBILL:
            return {
                ...state,
                OpticShopGenerateBillList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDGENERATEBILL:
            return {
                ...state,
                OpticShopGenerateBillSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDGENERATEBILL:
            return {
                ...state,
                OpticShopGenerateBillUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDGENERATEBILL:
            return {
                ...state,
                OpticShopGenerateBillDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDBILLITEM:
            return {
                ...state,
                OpticShopBillItemList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDBILLITEM:
            return {
                ...state,
                OpticShopBillItemSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDBILLITEM:
            return {
                ...state,
                OpticShopBillItemUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDBILLITEM:
            return {
                ...state,
                OpticShopBillItemDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDBILLTRANSACTION:
            return {
                ...state,
                OpticShopBillTransactionList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDBILLTRANSACTION:
            return {
                ...state,
                OpticShopBillTransactionSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDBILLTRANSACTION:
            return {
                ...state,
                OpticShopBillTransactionUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDBILLTRANSACTION:
            return {
                ...state,
                OpticShopBillTransactionDeleteStatus: action.payload.success,
            };

        case GETOPTICSHOPOPDPURCHASEITEMBILL:
            return {
                ...state,
                OpticShopPurchaseItemBillList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDPURCHASEITEMBILL:
            return {
                ...state,
                OpticShopPurchaseItemBillSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDPURCHASEITEMBILL:
            return {
                ...state,
                OpticShopPurchaseItemBillUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDPURCHASEITEMBILL:
            return {
                ...state,
                OpticShopPurchaseItemBillDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDPURCHASEITEMSHOW:
            return {
                ...state,
                OpticShopPurchaseItemShowList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDPURCHASEITEMSHOW:
            return {
                ...state,
                OpticShopPurchaseItemShowSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDPURCHASEITEMSHOW:
            return {
                ...state,
                OpticShopPurchaseItemShowUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDPURCHASEITEMSHOW:
            return {
                ...state,
                OpticShopPurchaseItemShowDeleteStatus: action.payload.success,
            };
        case GETOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION:
            return {
                ...state,
                OpticShopPurchaseItemBillTransactionList: action.payload.data,
            };
        case CREATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION:
            return {
                ...state,
                OpticShopPurchaseItemBillTransactionSaveStatus: action.payload.success,
            }
        case UPDATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION:
            return {
                ...state,
                OpticShopPurchaseItemBillTransactionUpdateStatus: action.payload.success,
            };
        case DELETEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION:
            return {
                ...state,
                OpticShopPurchaseItemBillTransactionDeleteStatus: action.payload.success,
            };

        case GETOPTICOPDVISIONCHART:
            return {
                ...state,
                OpticOpdVisionList: action.payload.data,
            };
        case CREATEOPTICOPDVISIONCHART:
            return {
                ...state,
                OpticOpdVisionSaveStatus: action.payload.success,
            }
        case UPDATEOPTICOPDVISIONCHART:
            return {
                ...state,
                OpticOpdVisionUpdateStatus: action.payload.success,
            };
        case DELETEOPTICOPDVISIONCHART:
            return {
                ...state,
                OpticOpdVisionDeleteStatus: action.payload.success,
            };

            case GETOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION:
                return { ...state, OpticShopItemSpecificationsList: action.payload.data, }
            case CREATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION:
                return { ...state, OpticShopItemSpecificationsSaveStatus: action.payload.success, }
            case UPDATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION:
                return { ...state, OpticShopItemSpecificationsUpdateStatus: action.payload.success, }
            case DELETEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION:
                return { ...state, OpticShopItemSpecificationsDeleteStatus: action.payload.success, }
    

        default:
            return state;
    }
}